import type { UserRoleEnum } from "@nlc/shared-types";

import { UserRoleEnum as Roles } from "@nlc/shared-types";
import { useMemo } from "react";

export type ProfileTabId = "manage-account" | "performance";

export interface ProfileTabDefinition {
  id: ProfileTabId;
  label: string;
}

export function useProfileTabs(roleId?: UserRoleEnum): ProfileTabDefinition[] {
  return useMemo(() => {
    if (!roleId) return [];

    const tabs: ProfileTabDefinition[] = [];

    if (roleId === Roles.Designer) {
      tabs.push({ id: "performance", label: "Performance" });
    }

    tabs.push({ id: "manage-account", label: "Manage Account" });

    return tabs;
  }, [roleId]);
}
